import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const processed = React.useRef(false);
  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/auth"); return; }
    const session_id = match[1];
    const role = localStorage.getItem("pending_role") || "guest";
    api.post("/auth/emergent/session", { session_id, role })
      .then(({ data }) => {
        localStorage.setItem("token", data.token);
        localStorage.removeItem("pending_role");
        const pending = localStorage.getItem("pending_redirect");
        localStorage.removeItem("pending_redirect");
        window.history.replaceState({}, "", "/");
        toast.success("Signed in!");
        // Honour pending redirect (deep-link back to /pool/... con selezione) altrimenti default per ruolo
        if (pending) {
          window.location.href = decodeURIComponent(pending);
        } else {
          window.location.href = data.user.role === "owner" ? "/owner" : "/";
        }
      })
      .catch(() => { toast.error("Sign-in failed"); nav("/auth"); });
  }, [nav]);
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#005C7A] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
}
